"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,1.99188419 L2,1.99188419 L2,13.0081158 C2,13.0023454 1.99765335,13 1.99406028,13 L14.0059397,13 C14.0022769,13 14,13.002273 14,13.0081158 L14,1.99188419 C14,1.99765461 14.0023466,2 14.0059397,2 L1.99406028,2 C1.99772311,2 2,1.99772697 2,1.99188419 L2,1.99188419 Z M0,1.99188419 C0,0.891796927 0.894513756,0 1.99406028,0 L14.0059397,0 C15.1072288,0 16,0.893397331 16,1.99188419 L16,13.0081158 C16,14.1082031 15.1054862,15 14.0059397,15 L1.99406028,15 C0.892771196,15 0,14.1066027 0,13.0081158 L0,1.99188419 L0,1.99188419 Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6",
    y: "7",
    width: "5",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "3 7.5 6 5 6 10"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(11.500000, 7.500000) scale(-1, 1) translate(-11.500000, -7.500000) ",
    points: "10 7.5 13 5 13 10"
  })));
};

exports["default"] = _default;